import devConfig from './config/config.dev.json';
import localConfig from './config/config.local.json';
import prodConfig from './config/config.prod.json';
import resizingConfig from './config/config.resizing.json';
import stageConfig from './config/config.stage.json';
import testConfig from './config/config.test.json';
import testBranchConfig from './config/config.testBranch.json';

interface Config {
    apiUrl: string;
    appUrl?: string;
    appUrlDjango?: string;
    env: string;
    gtmId?: string;
    homeUrl: string;
    usercentricsSettingsId?: string;
}

export const isProd =
    window.location.host.includes(prodConfig.appUrl) || window.location.host.includes(prodConfig.appUrlDjango);
export const isTest =
    window.location.host.includes(testConfig.appUrl) || window.location.host.includes(testConfig.appUrlDjango);
export const isResizing =
    window.location.host.includes(resizingConfig.appUrl) || window.location.host.includes(resizingConfig.appUrlDjango);
export const isStage =
    window.location.host.includes(stageConfig.appUrl) || window.location.host.includes(stageConfig.appUrlDjango);
export const isDev =
    window.location.host.includes(devConfig.appUrl) || window.location.host.includes(devConfig.appUrlDjango);
export const isTestBranch =
    window.location.host.includes(testBranchConfig.appUrl) || window.location.host.includes(testBranchConfig.appUrlDjango);
export const isRelease = window.location.host.includes('release-v');
export const isLocal = !isProd && !isTest && !isResizing && !isStage && !isStage && !isDev && !isTestBranch;
export const isStandaloneMode = process.env.REACT_APP_MODE !== 'django';

let config: Config = {
    apiUrl: '',
    env: '',
    homeUrl: '',
};

if (isProd) {
    config = prodConfig;
} else if (isStage || isRelease) {
    config = stageConfig;
} else if (isTest) {
    config = testConfig;
} else if (isResizing) {
    config = resizingConfig;
} else if (isDev) {
    config = devConfig;
} else {
    config = localConfig;
}

export const gtmId = config.gtmId;
export const usercentricsSettingsId = config.usercentricsSettingsId;

export const getConfig = (key: keyof Config) => {
    if (key in config && config[key] !== '') {
        return config[key] as string;
    }

    throw new Error(`Configuration variable ${key} in not set`);
};

!isProd && console.log('Environment configuration:', config);
